import { createContext, useContext } from "react";

export const HomeModeContext = createContext(null);

export const useHomeMode = () => {
  const context = useContext(HomeModeContext);
  return context || { isHomeMode: false, agentId: null, routeBase: "chats" };
};
